import { useEffect, useState } from "react";
import Header from "../components/common/header";
import Footer from "../components/common/footer";

export default function BehaviorDeepPage() {
  const [wallets, setWallets] = useState({});

  useEffect(() => {
    const ws = new WebSocket("wss://cryptospace.network/wallet-feed");

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        const p = msg.payload || {};
        const wallet = p.from || p.to;
        if (!wallet) return;

        setWallets((prev) => {
          const old = prev[wallet] || {
            total: 0,
            swap: 0,
            value: 0,
            contract: 0,
            bot: 0,
            gas: 0,
            zero: 0,
            complex: 0,
            transfer: 0,
            lastSeen: 0,
          };

          const updated = {
            ...old,
            total: old.total + 1,

            swap:
              old.swap +
              (msg.event === "REAL_SWAP" || msg.event === "SWAP_TOKENS" ? 1 : 0),

            value:
              old.value + (msg.event === "VALUE_TX" ? 1 : 0),

            contract:
              old.contract + (msg.event === "CONTRACT_CALL" ? 1 : 0),

            bot:
              old.bot + (msg.event === "BOT_LIKE_TX" ? 1 : 0),

            gas:
              old.gas + (msg.event === "GAS_SPIKE" ? 1 : 0),

            zero:
              old.zero + (msg.event === "ZERO_VALUE_LOGIC_CALL" ? 1 : 0),

            complex:
              old.complex + (msg.event === "COMPLEX_TX" ? 1 : 0),

            transfer:
              old.transfer + (msg.event === "ERC20_TRANSFER" ? 1 : 0),

            lastSeen: Date.now(),
          };

          return {
            ...prev,
            [wallet]: updated,
          };
        });
      } catch {}
    };

    return () => ws.close();
  }, []);

  const ranked = Object.entries(wallets)
    .map(([addr, w]) => {
      const score =
        w.swap * 80 +
        w.value * 60 +
        w.contract * 30 +
        w.bot * 100 +
        w.complex * 50 +
        w.gas * 20 +
        w.zero * 10 +
        w.transfer * 5;

      return { addr, ...w, score };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, 30);

  const getLabel = (w) => {
    if (w.bot > 50 && w.contract > 50) return "🤖 Contract Bot";
    if (w.bot > 50) return "🤖 Bot";
    if (w.swap > 20 && w.value > 10) return "💰 Smart Trader";
    if (w.contract > 50) return "🧠 Contract User";
    if (w.complex > 10) return "🧩 Complex Actor";
    if (w.gas > 10) return "⚠️ Gas Abuser";
    return "👤 Normal";
  };

  const getInsight = (w) => {
    if (w.bot > 50) return "High automation activity";
    if (w.swap > 20) return "Active trading behavior";
    if (w.contract > 50) return "Heavy smart contract usage";
    if (w.complex > 10) return "Advanced transaction patterns";
    if (w.value > 20) return "Frequent value transfers";
    return "Low activity profile";
  };

  return (
    <div style={{ minHeight: "100vh", background: "#000", color: "#fff" }}>
      <Header />

      <div style={{ padding: 24 }}>
        <h1 style={{ fontSize: 32, marginBottom: 10 }}>
          🧠 Deep Behavior Analysis
        </h1>

        <p style={{ color: "#aaa", marginBottom: 20 }}>
          Full signal-based wallet intelligence
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {ranked.map((w, i) => (
            <div
              key={w.addr}
              style={{
                padding: 16,
                border: "1px solid #222",
                borderRadius: 10,
                background: "#111",
              }}
            >
              <div style={{ fontSize: 12, color: "#777" }}>
                {w.addr}
              </div>

              <div style={{ fontSize: 20, margin: "6px 0" }}>
                #{i + 1} {getLabel(w)}
              </div>

              <div style={{ color: "#6ab7ff" }}>
                Score: {w.score}
              </div>

              <div style={{ fontSize: 13, marginTop: 6 }}>
                Total: {w.total}
              </div>

              <div style={{ fontSize: 13, color: "#aaa" }}>
                Swaps: {w.swap} | Value: {w.value}
              </div>

              <div style={{ fontSize: 13, color: "#aaa" }}>
                Contracts: {w.contract} | Bot: {w.bot}
              </div>

              <div style={{ fontSize: 13, color: "#aaa" }}>
                Complex: {w.complex} | Zero: {w.zero}
              </div>

              <div style={{ fontSize: 13, color: "#aaa" }}>
                Transfers: {w.transfer} | Gas: {w.gas}
              </div>

              <div style={{ marginTop: 8, color: "#9cff9c", fontSize: 13 }}>
                Insight: {getInsight(w)}
              </div>

              <div style={{ fontSize: 12, color: "#555", marginTop: 6 }}>
                last seen: {Math.floor((Date.now() - w.lastSeen) / 1000)}s ago
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}